import { action, observable, makeObservable } from 'mobx';

import {
  deepCopy,
  BetStatus,
  freeBetStore,
  userInfoStore,
  roundInfoStore,
  notificationStore,
} from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { BetResponseCode } from '@pascal/pascal-core/shared/core/enums/ResponseCodes';

import { reBetStore } from './reBetStore';
import { winnersStore } from './winnersStore';
import { totalBetStore } from './totalBetStore';

import { pigIndexes } from '../enums/pigColors';
import { gameLiveConnection } from '../services';
import { balanceChecker } from '../helpers/balanceChecker';

import { liveBetsDataStore } from './liveBetsDataStore';

class DoBetStore {
  isReBetDisabled = false;

  betAmountPopupId = null;

  autoCashOutQuickOdds = [];

  autoCashOutOddPopupId = null;

  pigsInitialData = [
    {
      betId: null,
      isSave: false,
      betAmount: null,
      winAmount: null,
      isDisabled: false,
      autoCashOutOdd: 0,
      id: pigIndexes.blue,
      isBetAccepted: false,
      isNextRoundBet: false,
      isNextRoundAutoCashOut: false,
    },
    {
      betId: null,
      isSave: false,
      betAmount: null,
      winAmount: null,
      isDisabled: false,
      autoCashOutOdd: 0,
      id: pigIndexes.red,
      isBetAccepted: false,
      isNextRoundBet: false,
      isNextRoundAutoCashOut: false,
    },
    {
      betId: null,
      isSave: false,
      betAmount: null,
      winAmount: null,
      isDisabled: false,
      autoCashOutOdd: 0,
      isBetAccepted: false,
      id: pigIndexes.yellow,
      isNextRoundBet: false,
      isNextRoundAutoCashOut: false,
    },
  ];

  pigs = deepCopy(this.pigsInitialData);

  constructor() {
    makeObservable(this, {
      pigs: observable.deep,
      betAmountPopupId: observable,
      autoCashOutOddPopupId: observable,
      autoCashOutQuickOdds: observable.deep,
      setWinData: action.bound,
      resetPigFreeBetId: action.bound,
      sendDoBets: action.bound,
      sendCashOut: action.bound,
      setDisabled: action.bound,
      setBetAmount: action.bound,
      setSavedPigs: action.bound,
      setCloudToRed: action.bound,
      setPigsData: action.bound,
      resetPigsData: action.bound,
      setCloudToBlue: action.bound,
      setDoBetResult: action.bound,
      handleReBetClick: action.bound,
      handleBetsClosed: action.bound,
      // decrementBalance: action.bound,
      setIsNexRoundBet: action.bound,
      setAutoCashOutOdd: action.bound,
      setBetAmountPopupId: action.bound,
      setIsAllNexRoundBet: action.bound,
      // incrementDemoBalance: action.bound,
      setAutoCashOutWinData: action.bound,
      mapRealBetsToPigsData: action.bound,
      handleShowNotification: action.bound,
      setAutoCashOutQuickOdds: action.bound,
      resetPigsDataOnRoundFin: action.bound,
      setIsNexRoundAutoCashOut: action.bound,
      setAutoCashOutOddPopupId: action.bound,
      // setDemoAutoCashOutWinData: action.bound,
      resetPigsDataOnResultReport: action.bound,
      setIsAllNexRoundAutoCashOut: action.bound,
    });
  }

  setSavedPigs(losePigIndex) {
    this.setCloudToRed(losePigIndex);
  }

  resetPigFreeBetId(itemId) {
    this.pigs.forEach((item) => {
      if (item.id === itemId && item.freeBetId) {
        item.freeBetId = null;
      }
    });
  }

  sendDoBets(data) {
    return gameLiveConnection.doBet(data);
  }

  setReBetDisabled(boolValue) {
    return this.isReBetDisabled === boolValue;
  }

  setPigsData(data) {
    this.pigs = data;
  }

  resetPigsData() {
    this.pigs = deepCopy(this.pigsInitialData);
  }

  setAutoCashOutQuickOdds(autoCashOutQuickOdds) {
    this.autoCashOutQuickOdds = autoCashOutQuickOdds;
  }

  setCloudToBlue() {
    this.pigs = this.pigs.map((pig) => ({ ...pig, isSave: false }));
  }

  setIsAllNexRoundBet(boolValue) {
    this.pigs = this.pigs.map((pig) => ({ ...pig, isNextRoundBet: boolValue }));
  }

  setBetAmount(pigId, betAmount, isFreeBet = true) {
    this.pigs = this.pigs.map((pig) => {
      if (pig.id === pigId) {
        if (isFreeBet) {
          pig.freeBetId = null;
          if (freeBetStore.activeFreeBet?.id) {
            pig.freeBetId = freeBetStore.activeFreeBet.id;
            pig.freeBetMinOdd = freeBetStore.activeFreeBet.minOdd;
            pig.freeBetAmount = freeBetStore.activeFreeBet.amount;
          }
        }
        return {
          ...pig,
          betAmount: pig.freeBetId ? pig.freeBetAmount : betAmount,
        };
      }
      return pig;
    });
  }

  setIsAllNexRoundAutoCashOut(boolValue) {
    this.pigs = this.pigs.map((pig) => ({
      ...pig,
      isNextRoundAutoCashOut: boolValue,
    }));
  }

  sendCashOut(betId) {
    // const demoCashOutModel = this.pigs.find((pig) => pig.betId === betId);
    //
    // return applicationStore.isDemo
    //   ? this.setWinData({
    //       ...demoCashOutModel,
    //       id: demoCashOutModel.betId,
    //       status: BetStatus.Win,
    //       roundId: roundInfoStore.roundId,
    //       amount: demoCashOutModel.betAmount,
    //       winAmount: demoCashOutModel.betAmount * oddStore.oddData[demoCashOutModel.id],
    //       additionalParams: {
    //         index: demoCashOutModel.id,
    //         autoCashoutOdd: demoCashOutModel.autoCashOutOdd,
    //       },
    //     })
    return gameLiveConnection.cashOut({
      betId: betId,
      roundId: roundInfoStore.roundId,
    });
  }

  setAutoCashOutOdd(pigId, autoCashOutOdd) {
    this.pigs = this.pigs.map((pig) => (pig.id === pigId ? { ...pig, autoCashOutOdd } : pig));
  }

  setCloudToRed(pigIndex) {
    this.pigs = this.pigs.map((pig) => (pig.id === pigIndex ? { ...pig, isSave: true } : pig));
  }

  setDisabled(id, boolValue) {
    this.pigs = this.pigs.map((pig) => (pig.id === id ? { ...pig, isDisabled: boolValue } : pig));
  }

  setBetAccepted(id, betId) {
    this.pigs = this.pigs.map((pig) =>
      pig.id === id ? { ...pig, betId, isBetAccepted: true } : pig
    );
  }

  setIsNexRoundBet(pigIndex) {
    this.pigs = this.pigs.map((pig) =>
      pig.id === pigIndex ? { ...pig, isNextRoundBet: false } : pig
    );
  }

  setIsNexRoundAutoCashOut(pigIndex, boolValue) {
    this.pigs = this.pigs.map((pig) =>
      pig.id === pigIndex ? { ...pig, isNextRoundAutoCashOut: boolValue } : pig
    );
  }

  handleShowNotification(betItem) {
    notificationStore.setNotificationType(BetResponseCode.InsufficientFunds);
    setTimeout(() => notificationStore.setNotificationType(null), 1000);
    totalBetStore.setTotalBetForNote(totalBetStore.totalBetForNote - betItem.betAmount);
    return { ...betItem, betAmount: 0 };
  }

  handleReBetClick() {
    const { setIsReBetClick, reBetInfo } = reBetStore;
    setIsReBetClick(true);
    if (!this.pigs.some((el) => el.betAmount) && reBetInfo.length) {
      this.pigs = reBetInfo.map((item) => ({
        ...item,
        betAmount: item.betAmount,
        isSave: this.pigs[item.id].isSave,
        autoCashOutOdd: item.autoCashOutOdd,
        isNextRoundBet: this.pigs[item.id].isNextRoundBet,
      }));
    }
    balanceChecker();
  }

  setAutoCashOutOddPopupId(id) {
    if (
      this.autoCashOutOddPopupId ||
      this.autoCashOutOddPopupId === 0 ||
      this.betAmountPopupId ||
      this.betAmountPopupId === 0
    ) {
      this.betAmountPopupId = null;
      this.autoCashOutOddPopupId = null;
    }
    this.autoCashOutOddPopupId = id;
  }

  setBetAmountPopupId(id) {
    if (
      this.autoCashOutOddPopupId ||
      this.autoCashOutOddPopupId === 0 ||
      this.betAmountPopupId ||
      this.betAmountPopupId === 0
    ) {
      this.betAmountPopupId = null;
      this.autoCashOutOddPopupId = null;
    }
    this.betAmountPopupId = id;
  }

  handleBetsClosed() {
    this.setIsAllNexRoundBet(true);
    this.setIsAllNexRoundAutoCashOut(true);
    this.pigs.forEach((pig) => {
      if (pig.betAmount) {
        const doBetModel = {
          freebetId: pig.freeBetId,
          amount: pig.betAmount,
          roundId: roundInfoStore.roundId,
          gameTypeId: gameConfigStore.gameTypeId,
          betData: {
            index: pig.id,
            autoCashoutOdd: pig.autoCashOutOdd,
          },
        };
        // if (applicationStore.isDemo) {
        //   totalBetStore.setTotalBet(this.pigs.reduce((acc, curr) => acc + curr.betAmount, 0));
        //   this.decrementBalance(pig.betAmount);
        //   this.setDoBetResult({
        //     ...doBetModel,
        //     status: BetStatus.Pending,
        //     id: createGuid(),
        //     responseCode: BetResponseCode.Success,
        //   });
        //   popupStore.updateDemoBetsCount();
        // } else {
        this.sendDoBets(doBetModel);
        // }
      }
    });
  }

  setDoBetResult(doBetData) {
    const {
      betData: { index, autoCashoutOdd },
      id,
      amount,
    } = doBetData;
    this.doBetResult = doBetData;
    this.setIsNexRoundBet(index);
    this.setDisabled(index, true);
    this.setBetAccepted(index, id);
    this.setBetAmount(index, amount, false);
    this.setIsNexRoundAutoCashOut(index, false);
    this.setAutoCashOutOdd(index, autoCashoutOdd);
    liveBetsDataStore.updateLiveBetsData(doBetData);
    reBetStore.setReBetInfo(
      this.pigs.map((pig) => ({
        ...pig,
        betId: null,
        isDisabled: false,
        isBetAccepted: false,
        isNextRoundBet: true,
        betAmount: pig.betAmount,
        isNextRoundAutoCashOut: true,
        autoCashOutOdd: pig.autoCashOutOdd,
      }))
    );

    if (this.autoCashOutOddPopupId === index) this.setAutoCashOutOddPopupId(null);

    // BET ACCEPTED MESSAGE
    notificationStore.setNotificationType(doBetData.responseCode);

    setTimeout(() => {
      if (notificationStore.notificationCode !== BetResponseCode.UnderMaintenanceNote) {
        notificationStore.setNotificationType(null);
      }
    }, 1000);
  }

  resetPigsDataOnResultReport(pigId, odd) {
    this.pigs = this.pigs.map((pig) =>
      pig.id === pigId &&
      (!pig.isBetAccepted ||
        (pig.isBetAccepted && !pig.autoCashOutOdd) ||
        (pig.isBetAccepted && pig.autoCashOutOdd && pig.autoCashOutOdd >= odd))
        ? {
            ...pig,
            betId: null,
            isDisabled: false,
            isBetAccepted: false,
            isNextRoundBet: true,
            isNextRoundAutoCashOut: true,
            betAmount: pig.isNextRoundBet && pig.isSave ? pig.betAmount : 0,
            autoCashOutOdd: pig.isNextRoundAutoCashOut ? pig.autoCashOutOdd : 0,
          }
        : pig
    );
  }

  resetPigsDataOnRoundFin(isFromDemoSwitcher) {
    this.pigs = this.pigs.map((pig) => ({
      ...pig,
      betId: null,
      isDisabled: false,
      isNextRoundBet: true,
      isBetAccepted: false,
      isNextRoundAutoCashOut: true,
      betAmount: pig.isNextRoundBet && !isFromDemoSwitcher ? pig.betAmount : 0,
      autoCashOutOdd: pig.isNextRoundAutoCashOut && !isFromDemoSwitcher ? pig.autoCashOutOdd : 0,
    }));
  }

  // incrementDemoBalance(amount, odd) {
  //   const balance = userInfoStore.balance + amount * odd;
  //   userInfoStore.setDemoBalance(balance);
  // }
  //
  // decrementBalance(amount) {
  //   userInfoStore.setDemoBalance(userInfoStore.balance - amount);
  // }

  setWinData(data) {
    // const { [DefaultQueryParams.UserId]: userId } = parseQuery(window.location.search);
    const updatedLiveBets = liveBetsDataStore.liveBetsData.map((item) =>
      item.id === data.betId ? { ...item, winAmount: data?.winAmount, status: data.status } : item
    );
    liveBetsDataStore.setLiveBetsData(updatedLiveBets);

    this.pigs = this.pigs.map((pig) => {
      if (
        pig.id === data?.additionalParams.index &&
        (+data.userId === +userInfoStore.userId || !data.userId)
      ) {
        // if (!applicationStore.isDemo) {
        setTimeout(() => gameLiveConnection.getBalance(), 200);
        // } else {
        //   this.incrementDemoBalance(pig.betAmount, oddStore.oddData[pig.id]);
        // }

        return {
          ...pig,
          isBetAccepted: false,
          winAmount: data.winAmount.toFixed(2),
        };
      }
      return pig;
    });

    setTimeout(() => {
      const updatedPigsData = this.pigs.map((pig) => {
        if (
          pig.id === data?.additionalParams.index &&
          (+data.userId === +userInfoStore.userId || !data.userId)
        ) {
          return {
            ...pig,
            betId: null,
            betAmount: 0,
            winAmount: null,
            isDisabled: false,
            isBetAccepted: false,
            isNextRoundBet: true,
            isNextRoundAutoCashOut: true,
            autoCashOutOdd: data?.additionalParams.autoCashoutOdd ? 0 : pig.autoCashOutOdd,
          };
        }
        return pig;
      });

      this.setPigsData(updatedPigsData);
    }, 1300);
  }

  setAutoCashOutWinData(data) {
    const { firstBets, secondBets, thirdBets } = data;
    // const { [DefaultQueryParams.UserId]: userId } = parseQuery(window.location.search);

    let userAcceptedBets = [
      ...(firstBets || []),
      ...(secondBets || []),
      ...(thirdBets || []),
    ].filter((item) => +item.userId === +userInfoStore.userId);

    userAcceptedBets = userAcceptedBets.filter((item) =>
      this.pigs.find(
        (pig) => item.additionalParams.index === pig.id && pig.isBetAccepted && pig.betId
      )
    );
    firstBets?.forEach((bet) => freeBetStore.freeBetTotalWinCalculator(bet));
    secondBets?.forEach((bet) => freeBetStore.freeBetTotalWinCalculator(bet));
    thirdBets?.forEach((bet) => freeBetStore.freeBetTotalWinCalculator(bet));

    if (userAcceptedBets && userAcceptedBets.length) {
      gameLiveConnection.getBalance();
      userAcceptedBets.forEach((item) => {
        this.pigs = this.pigs.map((pig) => {
          if (pig.id === item.additionalParams.index && pig.betId) {
            return {
              ...pig,
              isBetAccepted: false,
              winAmount: item.winAmount,
            };
          }
          return pig;
        });
      });

      setTimeout(() => {
        userAcceptedBets.forEach((item) => {
          const updatedPigsData = this.pigs.map((pig) => {
            return pig.id === item.additionalParams.index && pig.betId
              ? {
                  ...pig,
                  betId: null,
                  betAmount: 0,
                  winAmount: 0,
                  isDisabled: false,
                  autoCashOutOdd: 0,
                  isNextRoundBet: true,
                  isBetAccepted: false,
                  isNextRoundAutoCashOut: true,
                }
              : pig;
          });

          this.setPigsData(updatedPigsData);
        });
      }, 1300);
    }
  }

  // setDemoAutoCashOutWinData() {
  //   this.pigs = this.pigs.map((pig) => {
  //     if (+pig.autoCashOutOdd <= +oddStore.oddData[pig.id] && pig.autoCashOutOdd && pig.betId) {
  //       const updatedLiveBets = liveBetsDataStore.liveBetsData.map((item) =>
  //         item.id === pig.betId
  //           ? {
  //               ...item,
  //               winAmount: (pig.betAmount * pig.autoCashOutOdd).toFixed(2),
  //               status: BetStatus.Win,
  //             }
  //           : item
  //       );
  //       liveBetsDataStore.setLiveBetsData(updatedLiveBets);
  //       this.incrementDemoBalance(pig.betAmount, pig.autoCashOutOdd);
  //       return {
  //         ...pig,
  //         isBetAccepted: false,
  //         winAmount: (pig.betAmount * pig.autoCashOutOdd).toFixed(2),
  //       };
  //     }
  //     return pig;
  //   });
  //
  //   setTimeout(() => {
  //     const updatedPigsData = this.pigs.map((pig, index) => {
  //       return +pig.autoCashOutOdd <= +oddStore.oddData[index] && pig.autoCashOutOdd && pig.betId
  //         ? {
  //             ...pig,
  //             betId: null,
  //             betAmount: 0,
  //             winAmount: 0,
  //             isDisabled: false,
  //             autoCashOutOdd: 0,
  //             isNextRoundBet: true,
  //             isBetAccepted: false,
  //             isNextRoundAutoCashOut: true,
  //           }
  //         : pig;
  //     });
  //
  //     this.setPigsData(updatedPigsData);
  //   }, 1300);
  // }

  mapRealBetsToPigsData(freeBetsList = []) {
    // popupStore.setDemoBetsCount(0);
    // const { [DefaultQueryParams.UserId]: userId } = parseQuery(window.location.search);
    const filteredBets = liveBetsDataStore.liveBetsData?.filter(
      (item) => +item.userId === +userInfoStore.userId
    );
    gameLiveConnection.getBalance();
    liveBetsDataStore.setLiveBetsData([]);
    winnersStore.winnersData = winnersStore.winnersData.filter((item) => item.userId);

    if (filteredBets && filteredBets.length) {
      filteredBets.forEach((item) => {
        const {
          id,
          betData: { index, autoCashoutOdd },
          freeBetId,
          amount,
        } = item;
        if (+item.userId === +userInfoStore.userId) {
          totalBetStore.setTotalBet(totalBetStore.totalBet + amount);
          if (item.status === BetStatus.Pending) {
            const currentFreeBet = freeBetsList.find((freeBet) => freeBet.id === freeBetId);
            this.pigs = this.pigs.map((pig) => {
              if (pig.betId) this.setReBetDisabled(true);
              if (pig.id === index && !pig.isSave) {
                return {
                  ...pig,
                  betId: id,
                  isDisabled: true,
                  freeBetMinOdd: currentFreeBet?.id ? currentFreeBet.minOdd : null,
                  freeBetId: currentFreeBet?.id || null,
                  betAmount: amount,
                  isBetAccepted: true,
                  isNextRoundBet: !amount,
                  autoCashOutOdd: autoCashoutOdd,
                  isNextRoundAutoCashOut: !autoCashoutOdd,
                };
              }
              return pig;
            });
          }
        }
      });
    } else {
      reBetStore.setReBetInfo([]);
      totalBetStore.setTotalBet(0);
      this.resetPigsDataOnRoundFin(true);
    }
  }
}

export const doBetStore = new DoBetStore();
